import { useState } from 'react'
import { Avatar, IconButton, Tooltip, Typography, useMediaQuery, Box } from '@mui/material'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Close } from '@mui/icons-material'
import { onMessage } from 'firebase/messaging'
import { useSnackbar } from 'notistack';
import useGetNotificationTokenAndSendToBackend from '../../../hooks/useGetNotificationTokenAndSendToBackend'
import { selectAuthUser } from '../../../redux/features/userAuth/userAuthSlice'
import UserMenu from './userMenu'
import { firebaseMessaging } from '../../../services/Firebase'
import AlarmIcon from '../../../images/alarm.svg'
import NotificationsBellsGroup from './NotificationsBellsGroup'

const Index = () => {
  const isXsScreen = useMediaQuery((theme) => theme.breakpoints.up('md'));
  const [anchorElUser, setAnchorElUser] = useState(null)
  const { authorizedUser } = useSelector(selectAuthUser)
  useGetNotificationTokenAndSendToBackend()
  const history = useHistory()

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget)
  }

  const handleCloseUserMenu = () => {
    setAnchorElUser(null)
  }

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const pushSnackbar = ({
    title, description, id,
  }) => enqueueSnackbar('', {
    key: id,
    autoHideDuration: 3000,
    anchorOrigin: {
      vertical: 'top',
      horizontal: !isXsScreen ? 'center' : 'right',
    },
    content: (
      <Box sx={styles.notificationComponent}>
        <Box sx={styles.notificationCard2}>
          <img src={AlarmIcon} alt="AlarmIcon" />
        </Box>
        <Box sx={{ width: '100%' }}>
          <Typography sx={styles.time}>
            Just Now
            <Close sx={styles.icon} onClick={() => closeSnackbar(id)} />
          </Typography>

          <Typography sx={styles.title}>
            { title }
          </Typography>

          <Typography sx={styles.description}>
            { description.length < 156 ? description : (`${description.slice(0, 150)}...`) }
          </Typography>

          <Typography
            sx={styles.textBtn}
            onClick={() => history.push('/notifications')}
          >
            Notification Center
          </Typography>
        </Box>

      </Box>
    ),
  });

  onMessage(firebaseMessaging, (msg) => {
    pushSnackbar({
      title: msg?.notification?.title,
      description: msg?.notification?.body,
      id: msg?.messageId,
    })
  });

  return (
    <Box sx={styles.root}>

      <NotificationsBellsGroup />

      {isXsScreen && (
        <>
          <Tooltip title='Open settings'>
            <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
              <Avatar
                alt={authorizedUser?.name?.toUpperCase() || 'SW'}
                src='/static/images/avatar/2.jpg'
              />
            </IconButton>
          </Tooltip>

          <UserMenu menuState={anchorElUser} changeMenuState={handleCloseUserMenu} />
        </>
      )}
    </Box>
  )
}
const styles = {
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    p: 0,
    gap: '20px',
    '& svg:nth-child(1)': {
      fontSize: '30px',
      cursor: 'pointer',
    },

    '& svg': {
      color: 'white',
    },
  },
  flexBetween: { display: 'flex', justifyContent: 'space-between', my: '5px' },
  sideBtn: {
    border: '0',
    color: 'text.hint',
    padding: '0',
    backgroundColor: 'transparent',
    '&: hover': {
      backgroundColor: 'transparent',
    },
  },
  sideButtonContainer: { width: '290px !important' },
  text: {
    fontSize: '14px',
    fontWeight: '500',
  },
  textColor: { color: '#29CC8B', cursor: 'pointer' },
  cardTime: {
    fontSize: '12px',
    color: '#92929D',
    display: 'block',
  },
  notificationsNoneOutlinedIcon: {
    fill: '#29CC8B',
    fontSize: '25px !important',
    margin: '3px',
  },
  notificationCardList: {
    maxHeight: '300px',
    overflowY: 'scroll',
    '::-webkit-scrollbar': {
      width: '0.3em',
    },
    '::-webkit-scrollbar-track': {
      '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)',
    },
    '::-webkit-scrollbar-thumb': {
      backgroundColor: 'primary.main',
    },
  },
  notificationCard: {
    display: 'flex',
    gap: '16px',
    padding: '10px 0',
  },
  notificationIconContainer: {
    height: '32px',
    width: '32px',
    borderRadius: '10px',
    backgroundColor: '#EAFAF3',
  },
  padge: {
    '& span.MuiBadge-badge.MuiBadge-dot.MuiBadge-anchorOriginTopRight.MuiBadge-anchorOriginTopRightRectangular.MuiBadge-overlapRectangular.MuiBadge-colorError ': {
      transform: 'scale(1) translate(-50%, 30%)',
    },
  },

  notificationComponent: {
    width: { xs: '300px', sm: '500px' },
    maxHeight: '160px',
    display: 'flex',
    backgroundColor: '#FFF',
    zIndex: 9999,
    filter: 'drop-shadow(0px 8px 16px rgba(0, 0, 0, 0.16))',
    borderRadius: '12px',
    '&: hover': {
      '& svg': {
        visibility: 'visible',
      },
    },
  },
  notificationCard2: {
    width: { xs: '55px', sm: '80px' },
    flexShrink: 0,
    backgroundColor: '#29CC8B',
    borderRadius: '12px 0px 0px 12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& img': {
      width: { xs: '40px', sm: '50px' },
      height: { xs: '40px', sm: '50px' },
    },
  },
  time: {
    padding: '10px',
    pb: '0',
    br: '0',
    color: '#AFAFAF',
    fontSize: '12px',
    fontWeight: 300,
    marginRight: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'end',
    columnGap: '11px',
  },
  icon: {
    color: '#29CC8B',
    width: '15px',
    cursor: 'pointer',
    visibility: 'hidden',
  },
  title: {
    color: '#000',
    fontSize: '16px',
    fontWeight: 500,
    ml: '14px',
  },
  description: {
    color: '#000',
    fontSize: '14px',
    fontWeight: 300,
    fontStyle: 'normal',
    ml: '14px',
    mt: '5px',
    width: { xs: '230px', sm: '385px' },
  },
  textBtn: {
    color: '#29CC8B',
    fontSize: '13px',
    fontWeight: 500,
    fontStyle: 'normal',
    width: 'fit-content',
    textAlign: 'right',
    cursor: 'pointer',
    p: '5px 15px',
    borderRadius: '12px',
    display: 'flex',
    marginLeft: 'auto',
    marginBottom: '4px',
    transition: 'all .5s',
    mr: '4px',
    alignSelf: 'end',
    '&: hover': {
      backgroundColor: '#ECEFF1',
    },
  },

}

export default Index
